import AdminActionGroup from "./AdminActionGroup";

export default function AdminToolbar({
  filters = null,
  actions = null,
  maintenanceActions = null,
  className = "",
}) {
  if (!filters && !actions && !maintenanceActions) {
    return null;
  }

  return (
    <div className={`admin-console__toolbar${className ? ` ${className}` : ""}`}>
      {filters ? <div className="admin-console__toolbar-filters">{filters}</div> : null}
      {actions || maintenanceActions ? (
        <div className="admin-console__toolbar-actions">
          {actions}
          {maintenanceActions ? (
            <AdminActionGroup tone="maintenance">{maintenanceActions}</AdminActionGroup>
          ) : null}
        </div>
      ) : null}
    </div>
  );
}
